exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loading-progress {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 6px;  /* 增加高度 */\n\tbackground: rgba(0,0,0,0.1);  /* 改为半透明背景 */\n\tz-index: 10;\n}\n.progress-bar {\n\theight: 100%;\n\twidth: 0;\n\tbackground: linear-gradient(90deg, #FDD100, #FF8C00);  /* 添加渐变效果 */\n\tbox-shadow: 0 0 10px rgba(253,209,0,0.6);  /* 添加发光效果 */\n\tanimation: progress 1.5s ease-in-out infinite;  /* 加快动画速度 */\n}\n@keyframes progress {\n0% { width: 0; opacity: 0.8;\n}\n50% { width: 80%; opacity: 1;\n}\n100% { width: 100%; left: 100%; opacity: 0.8;\n}\n}\n", ""]);

// exports
